exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".img-heading[data-v-3df3f458]{width:80px;height:80px;min-width:80px;min-height:80px}.img-heading[data-v-3df3f458],.img-risposta[data-v-3df3f458]{transition:box-shadow .3s ease-in-out;box-shadow:1px 8px 10px -6px #6c757d;object-fit:cover}.img-risposta[data-v-3df3f458]{width:45px;height:45px;min-width:45px;min-height:45px}", ""]);

// exports
